import specialDates from "./data/JSON_SPECIAL_DATES.json";
export default {
  token: null,
  role: null,
  status: null,
  first_signin: null,
  advertisements: null,
  collectionMonths: null,
  specialDates: specialDates,
  favoritesAds: null,
  premium_ads: null,
  ads_total: 0,
  topBrands: null,
  freeTopBrands: null,
  tiktoks: null,
  directory: null,
  cases: null,
  freeCases: null,
  favoritesTopBrands: null,
  favoritesTiktoks: null,
  totalAdvertisements: 99,
  totalFbandIG: 99,
  totalTopBrands: 99,
  totalTiktoks: 99,
  totalDirectory: 99,
  totalCases: 99,
  totalDiscover:99,
  currentAd: null,
  nextIdAd: null,
  prevIdAd: null,
  adsPerPage: 30,
  freeAdsPerPage: 30,
  page: 1,
  pageTiktoks: 1,
  pageTopBrands: 1,
  pageDirectory: 1,
  pageCases: 0,
  nextPage: 1,
  selectedHook: null,
  verbalHooks: null,
  totalVerbalHooks: 99,
  pageVerbalHooks: 1,
  totalUgcCreators: 99,
  ugcCreators: null,
  pageUgcCreators: 1,
  selectedUgcCreator: null,
  titlesSubtitles: null,
  tiktokTitleSubtitle: null,
  fbIgTitleSubtitle: null,
  discoverSubtitle: null,
  topBrandTitleSubtitle: null,
  hooksTitleSubtitle: null,
  calendarTitleSubtitle: null,
  adsToTestFirstTitleSubtitle: null,
  psycologyTitleSubtitle: null,
  caseStudiesTitleSubtitle: null,
  dealsToolsTitleSubtitle: null,
  ourProcessTitleSubtitle: null,
  ugcCreatorsTitleSubtitle: null,
  totalUsers: null,
  hooks: [
    {
      video_name: "Blurred",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/836879b1-2028-4eda-bcdc-879255aae2a9.mp4",
        "https://nodolandstorage.s3.amazonaws.com/dae6048f-b161-46bd-b844-7a1859e8bffb.mp4",
        "https://nodolandstorage.s3.amazonaws.com/0a82fbf4-2db0-4f53-8218-ef377667c2aa.mp4",
      ],
      analysis:
        "When Facebook videos load, they all have one thing in common, a momentary blurry screen. Use this by kicking off your video with an equally blurry image, just for a few seconds. This little trick is a slight deviation from the norm, so it’s likely to stand out to scrollers.",
    },
    {
      video_name: "Close Ups",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/15e8b4f7-9fe8-4e52-aa26-18d652df9f1c.mp4",
        "https://nodolandstorage.s3.amazonaws.com/3b904347-0ad9-4c1b-93bc-0a2b98c940f6.mp4",
      ],
      analysis:
        "Close-ups scenes are immediately interesting and grab the eye of the viewer straight away. You can use this type of hook to highlight the quality of your product.",
    },
    {
      video_name: "Emotions",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/0d352d03-b101-4f9b-9b77-30d1000e3347.mp4",
        "https://nodolandstorage.s3.amazonaws.com/e51b6f2a-f039-43cc-80da-7dee578deca0.mp4",
      ],
      analysis:
        "A person’s expression can be easily interpreted and it is also very powerful. Remember! Giving the human touch to the first few seconds of your ad will make it more interesting.",
    },
    {
      video_name: "Bold Question",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/aefeed25-389e-416e-9f0b-aaea3f625c03.mp4",
        "https://nodolandstorage.s3.amazonaws.com/e7894303-0303-4904-a5e1-05599f52215c.mp4",
      ],
      analysis:
        "A powerful question or statement is a great way to grab the eyes of the viewer within just a few seconds. The secret to it is to make it short and sweet.",
    },
    {
      video_name: "Visual Hook",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/f45ee749-6d3a-473b-a12e-3ed41405f27d.mp4",
        "https://nodolandstorage.s3.amazonaws.com/c843ea9c-aafb-4394-9e85-0587376f6344.mp4",
      ],
      analysis:
        "Movement is key to making your ad pop! Start your ad with interesting movements to make the video as interesting as possible.",
    },
    {
      video_name: "Reveal/Zoom Out",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/42ddbd45-73db-4048-8923-c62907e04c05.mp4",
        "https://nodolandstorage.s3.amazonaws.com/6ed04368-b9f1-49f9-b105-6aa45bf0cf88.mp4",
        "https://nodolandstorage.s3.amazonaws.com/18ba7192-0b47-4016-bb88-c8f0fb1e5509.mp4",
      ],
      analysis:
        "Take advantage of the visuals of your ad and grab the attention of the viewer with a zoom-out that reveals your product straight away!",
    },
    {
      video_name: "Interactive format",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/35463be2-eee0-4778-951d-db9a5b321744.mp4",
        "https://nodolandstorage.s3.amazonaws.com/43a6e78c-471b-498f-92d6-80c115e606b7.mp4",
      ],
      analysis:
        "A great way to grab the attention of a viewer is to create an ad that is easily recognisable from the start and get the viewer to be as involved as possible. Interactive formats are great because this type of ad is both interesting and relatable. ",
    },
    {
      video_name: "Text messages",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/6f0e1b5e-df9f-4dca-b14f-e670cd9163ff.mp4",
        "https://nodolandstorage.s3.amazonaws.com/77686c6e-4ab4-4257-b1cf-98e6a06c5367.mp4",
      ],
      analysis:
        "A great hook we are seeing is the use of text message format to hook the viewer! Simple messages - usually depicting the conversation between 2 friends or a brand is a great way to showcase an interesting visual.",
    },
    {
      video_name: "Unboxing",
      video_link: [
        "https://nodolandstorage.s3.amazonaws.com/216a6f1b-8e66-464a-99b5-79da10beedbd.mp4",
        "https://nodolandstorage.s3.amazonaws.com/37080b10-a0e7-4fbe-ae84-70c573011cd9.mp4",
        "https://nodolandstorage.s3.amazonaws.com/48640a63-57ed-4d1b-8583-8e27bc73d7c4.mp4",
      ],
      analysis:
        "Another great way to reveal your product is with a quick unboxing scene to reveal it. From there, you can develop your ad in so many ways.",
    },
  ],
  selectedAdTest: null,
  adsTestFirst: [
    {
      video_name: "UGC Product Testing",
      creator: "Warby Parker",
      analysis:
        "UGC ads are working great! This type of ad is an organic display and reaction to your product. The key to this ad is to make it natural and focus on the features of the product and how they will help the customer.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/d3203d68-52fe-4b61-ab99-aa97dcd66a11.mp4",
    },
    {
      video_name: "Standard vs Our product",
      creator: "Magic Spoon Cereal",
      analysis:
        "The US vs Them is very powerful in advertising and this type of ad takes advantage of this. With this direct comparison, you can enhance the features of your product and keep the viewer watching. ",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/27973925-4d97-4398-834c-8b5e16372afe.mp4",
    },
    {
      video_name: "Upgrade to",
      creator: "Bella and canvas",
      analysis:
        "It all starts with a very clear depiction of the flaws of the competition followed by the word “Upgrade to” and immediately switches to the benefits of your product. A great way to create a good value proposition for your ads",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/a076aad7-d971-4427-a713-21db6c20159b.mp4",
    },
    {
      video_name: "Interative Chat",
      creator: "Peatos",
      analysis:
        "This style of ad relies on a text-based conversation between the client and the brand. With this ad, you can send effective messages to your audience, at the same time, the organic appeal of this type will help you and your brand become more relatable.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/a031437d-0605-4734-8f16-46622b91fbba.mp4",
    },
    {
      video_name: "What you can do with",
      creator: "Jot",
      analysis:
        "A great style of ad that allows you to showcase your product as it is meant to be used. Simply start with the very catchy and powerful “How to…” and take your audience through a journey to discover the benefits of your product. Make sure to add human interaction to make the ad more effective.        ",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/3b138386-3852-4067-bc4f-2c8ed67cce77.mp4",
    },
    {
      video_name: "Before and after",
      creator: "Tooletries",
      analysis:
        "This type of ad is all about clarity. You need to contrast the difference between the before and after. If possible, try to keep the ad as organic as possible, don’t overproduce it. A simple text to highlight the features, transitions to switching between ideas, and a final CTA is all you need to get a great video ad.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/25f67f9f-212a-4c2b-8bae-09dea97e726b.png",
    },
    {
      video_name: "Client Testimonial",
      creator: "-",
      analysis:
        "The key to this type of ad is to keep it organic! A client testimonial is a great way to convince your viewers at the bottom of the funnel. You can also combine this type of ad with great animation and shots of your product being used to highlight its value. (testimonial)",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/69388671-2d3f-48e7-b937-cc4862d2e547.mp4",
    },
    {
      video_name: "How to",
      creator: "-",
      analysis:
        "A great type of ad that allows you to provide pre-purchase value to your product and make it more achievable at the same time. Experiment with organic shots, hand-held and showing hands manipulating your product. This way, the whole message seems much more relatable.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/cad265dc-c9aa-4a29-bcdf-766823a4d0ac.mp4",
    },
    {
      video_name: "Reasons to buy",
      creator: "-",
      analysis:
        "The key to a great ad is often a simple message. This type of ad allows you to do a summary of your offer in bullet points which is easier to digest by your audience. It also helps you highlight a very important idea; why your audience needs to buy this product",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/bb5d779b-3d78-4885-899d-3911836358a5.mp4",
    },
    {
      video_name: "How to buy - screen recording",
      creator: "-",
      analysis:
        "This is a great scroll stopper! With this type of ad, you can increase interaction and at the same time, it helps your product become more relatable and achievable.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/af407643-4738-4acd-a251-aea0ce4865b2.mp4",
    },
    {
      video_name: "Slide Show",
      creator: "-",
      analysis:
        "This type of video allows you to show your product and a quick message, and use a video to highlight the main message of the ad and grab the attention of the viewer.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/cc1a51bb-cb41-42d0-9bf9-ea061d52b834.mp4",
    },
    {
      video_name: "Video in Image",
      creator: "-",
      analysis:
        "This type of video allows you to show your product and a quick message, and use a video to highlight the main message of the ad and grab the attention of the viewer.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/24ae2443-72f7-4e4d-bd1e-7759df8c38ff.mp4",
    },
    {
      video_name: "Over background video",
      creator: "-",
      analysis:
        "This type of ad allows you to show your product and also give some context to your message. The first tip for this type of ad is to keep it simple, with basic animation and text. Secondly, make your product pop by using contrasting colours in the background. ",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/41c2a93d-c71b-47aa-83d4-ce097fb0487f.mp4",
    },
    {
      video_name: "Reaction",
      creator: "-",
      analysis:
        "This is an organic video (often handheld) that shows the reaction of a person to a product. This type of ad is always a great alternative because you can easily display your product, and also link your brand to a particular feeling. Make sure to make it fun and focus on the expression of the people.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/4222fa68-547d-41ba-97d3-7048e7771a17.mp4",
    },
    {
      video_name: "Unboxing",
      creator: "-",
      analysis:
        "Unboxing is a great ad type that allows you to fully display your product, and at the same time provide a clear message to your audience. One advantage of this ad is that it has been a proven scroll-stopper.",
      video_link:
        "https://nodolandstorage.s3.amazonaws.com/cdf0c29a-d5af-4b31-b7b9-4afbc31d6601.mp4",
    },
  ],
  filters: {
    search: "",
    industry: "",
    type: "",
    objective: "",
    format: "",
    platform: "",
    exist_analysis: "",
    month: null,
  },
  filters_tiktoks: {
    search: "",
    industry: "",
    is_ad: null,
    month: null,
  },
  filters_topBrands: {
    search: "",
    industry: "",
    country: "",
  },
  filters_ugcCreators: {
    search: "",
    industry: "",
    country: "",
    gender: "",
  },
  industries: [
    {
      label: "Food/Drink",
      value: "Food/Drink",
      values: ["Drinks", "Food", "Other"],
    },
    {
      label: "Fashion",
      value: "Fashion",
      values: ["Accesories/jewelry", "Clothing", "Footwear", "Other"],
    },
    { value: "Health/Wellness", values: ["Suplements", "Other"] },
    { value: "Beauty/Cosmetics" },
    {
      value: "Home",
      values: ["Furniture", "Decoration", "Landscaping", "Other"],
    },
    { value: "Kids/Baby", values: ["Fashion", "food and drinks", "Other"] },
    { value: "Pets", values: ["Food", "Accesories", "Other"] },
    { value: "Other" },
  ],
  types: [
    "Unboxing",
    "Lifestyle",
    "Social Proof",
    "Discount",
    "Humor",
    "Ilustration",
    "How-to/Features",
    "UGC",
    "Seasonal",
  ],
  countries: [
    { label: "US", value: "US" },
    { label: "CA", value: "CA" },
    { label: "UK", value: "UK" },
    { label: "NZ", value: "NZ" },
    { label: "AU", value: "AU" },
  ],
  genders: ["Woman", "Man"],
  ugc_countries: [
    { label: "Australia", value: "Australia" },
    { label: "Canada", value: "Canada" },
    { label: "Dominican Republic", value: "Dominican Republic" },
    { label: "Finland", value: "Finland" },
    { label: "France", value: "France" },
    { label: "Germany", value: "Germany" },
    { label: "Great Britain", value: "Great Britain" },
    { label: "Greece", value: "Greece" },
    { label: "Irland", value: "Irland" },
    { label: "Italy", value: "Italy" },
    { label: "Korea", value: "Korea" },
    { label: "Mexico", value: "Mexico" },
    { label: "Netherlands", value: "Netherlands" },
    { label: "Nigeria", value: "Nigeria" },
    { label: "Norway", value: "Norway" },
    { label: "Romania", value: "Romania" },
    { label: "South Africa", value: "South Africa" },
    { label: "Spain", value: "Spain" },
    { label: "United States", value: "United States" },
  ],
  objectives: [
    { label: "Prospecting", value: "prospecting" },
    { label: "Retargeting", value: "retargeting" },
  ],
  formats: [
    { label: "Video", value: "video" },
    { label: "Static Image", value: "static image" },
  ],
  platforms: [
    { label: "Facebook & IG", value: "facebook" },
    { label: "Tiktok", value: "tiktok" },
  ],
  exists_analysis: [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ],
  user: null,
  subscription: null,
  transaction: null,
  ourPlansIsActive: false,
  subscriptionPlan: null,
  plans: null,
};
